<template>
	<div style="position: relative;height:300px;">
		<img src="../assets/top_logo.png" >
		
		<div style="margin-top:20px;position: absolute;top: 50%;left: 50%;transform: translateY(-50%) translateX(-50%);-webkit- transform: translateY(-50%) translateX(-50%);">
		<br><br><br><br><br><br><br><br>
		<div class="inputItemDiv" style="width:520px;"><div style="color:red;">{{message}}</div></div>
		<div class="inputItemDiv" style="width:520px;">
		<div class="inputTitleDiv"  style="width:180px; height:38px; font-size:large;">ID</div>
		<input class="input" type="text" style="width:320px; height:32px; font-size:large;" v-model="loginForm.userid">
		</div>

		<div class="inputItemDiv" style="width:520px;">
		<div class="inputTitleDiv" style="width:180px; height:38px; font-size:large;">パスワード</div>
		<input class="input" type="password" v-model="loginForm.password" style="width:320px; height:32px; font-size:x-large;">
		</div>
	
		<div class="inputItemDiv" style="text-align: right; width:520px;">
			<button  type="button" class="button" @click='cancel' style="width:125px; height:30px; font-size:small;">キャンセル</button>
			<button :disabled="resAllVal"  type="button" class="button" @click='login' ref="loginBtn" style="width:125px; height:30px; font-size:small;">ログイン</button>
		</div>
		</div>
	</div>

</template>

<script>
import accountRepository from '../composables/AccountRepository'
import { useRouter  } from 'vue-router'


import {ref} from 'vue';
import store from '@/store/index';

export default ({
  name: 'Login',
  setup(){
  
    //エンターキー押下時にログインボタン押下
    const loginBtn = ref(null)
    
    const onKeyDown  = (event) => {
      if( event.key == 'Enter'){
        loginBtn.value.click()
      }
    }
    
    document.addEventListener('keydown', onKeyDown)
    //
 
  
    const loginForm = ref( {userid:'', password:''} )
    const message = ref(null)
    
    //AccountRepositoryモジュールからの変数、メソッドを宣言
    const { loginAccount } = accountRepository()


    //ルータ使用変数宣言
    //const route = useRoute()
    const router = useRouter()
    
    const login = () =>{
      console.log( loginForm )
      loginAccount( loginForm, callback )
    }
    
    const cancel = () =>{
      loginForm.value.userid = ''
      loginForm.value.password = '' 
    }
    
    //データ取得時のコールバック( GoodsRepositoryのgetGoodsByIdメソッドに渡す)
    const callback = ( result ) =>{
      if( result == "Error"){
          message.value = "ユーザID又はパスワードが間違っています。"
      }else if( result == "Success"){
        console.log(store.getters.getAuthToken)
        router.push("/catalogList")
      }else{
        var data = result.response.data
        //if( data.startsWith("Error")){
        //  message.value = "ユーザID又はパスワードが間違っています。"
        //}else{
        console.log( data)
        if( data.status == 401 ){
          message.value = "ユーザID又はパスワードが間違っています。"
        }else{
          message.value = data.error
        }
        //}
      }
    }
    


    //GoodsValidatorモジュールからの変数、メソッドを宣言
    //resName:名称入力チェック結果
    //resPricceVal:価格入力チェック結果
    //resAllVal:全ての項目の入力チェック結果
    //const{ resNameVal, resAllVal } = catalogValidator( catalog )


    
    //template上で使用する変数を宣言
    return{
      loginForm,
      login,
      cancel,
      message,
      loginBtn
    }
  }

})

</script>


